export default function Badge(theme) {
    return {
        MuiBadge: {
            styleOverrides: {
                dot: ({ ownerState })=>({
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: !ownerState.color || ownerState.color === 'default' ? theme.palette.background.default : undefined
                    }),
                standard: ({ ownerState })=>{
                    if (!ownerState.color || ownerState.color === 'default') {
                        return {
                            color: theme.palette.text.primary,
                            backgroundColor: theme.palette.background.default,
                            fontWeight: 700,
                            padding: 0
                        };
                    }
                    return {
                        color: theme.palette.primary.contrastText,
                        backgroundColor: theme.palette[ownerState.color].main,
                        fontWeight: 700
                    };
                }
            }
        }
    };
}
